import React from 'react';
import PropTypes from 'prop-types';
import {
  Column, Divider, Row, Typography,
} from '@tempmee/react';
import { useMemberReceivedFeedback } from '../../../../domain/Awards';
import { MemberAnswerList } from './MemberAnswerList';
import { MemberContentDialog, memberShape } from './MemberContentDialog';

/**
 * Every review written *about* this member, opened from the Feedback tick.
 *
 * Received, never given — the same meaning the tick already carries. Nobody
 * having reviewed them yet is a 200 with an empty list, so that lands on the
 * shell's empty branch rather than its error one.
 */
export const MemberFeedbackDialog = ({ open, onClose, cycleId, member }) => {
  const { feedback, isPending, isError } = useMemberReceivedFeedback(cycleId, member.userId);

  return (
    <MemberContentDialog
      open={open}
      onClose={onClose}
      title={`Feedback for ${member.displayName}`}
      isPending={isPending}
      isError={isError}
      isEmpty={feedback.length === 0}
      loadingMessage="Loading feedback…"
      errorMessage="Could not load this feedback."
      emptyMessage="Nobody has reviewed this member in this cycle yet."
    >
      <Column gap={5}>
        {feedback.map((review, index) => (
          // At most one review per reviewer per member per cycle, so the
          // reviewer's id is a stable key even before the list is sorted.
          <Column key={review.reviewerUserId} gap={4}>
            {index > 0 ? <Divider /> : null}

            <Row align="baseline" justify="between" gap={4}>
              <Typography variant="subtitle2" bold numberOfLines={1}>
                {review.reviewerName}
              </Typography>
              <Typography variant="body2" className="shrink-0 text-text-secondary">
                {review.submittedAtLabel}
              </Typography>
            </Row>

            <MemberAnswerList answers={review.answers} applicantName={member.name} />
          </Column>
        ))}
      </Column>
    </MemberContentDialog>
  );
};

MemberFeedbackDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cycleId: PropTypes.string.isRequired,
  member: memberShape.isRequired,
};
